import gql from 'graphql-tag';

export const GET_GLOBAL_EQUIPMENT_OPTIONS = gql`
  query GetGlobalEquipmentOptions($input: EquipmentOptionsInput!) {
    globalEquipment {
      result: options(input: $input) {
        error
        success
        entity {
          makes {
            value
            label
          }
          models {
            value
            label
          }
          years {
            value
            label
          }
        }
      }
    }
  }
`;
